import React, { useEffect } from "react";
import Transactions from "../../../Components/PaymentLedger/Transactions/Transactions";
import { useDispatch } from "react-redux";
import { walletTransaction } from "../../../Redux/Slices/paymentSlice";

const Page_Transaction = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(walletTransaction());
  }, []);
  return <Transactions />;
};

export default Page_Transaction;
